"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensionsAsMeasuresDict = void 0;
const columnTypes_1 = require("../columnTypes");
exports.dimensionsAsMeasuresDict = {
    [columnTypes_1.ColumnTypes.DimensionAsMeasure]: true,
    [columnTypes_1.ColumnTypes.DimensionAsMeasureCPA]: true,
    [columnTypes_1.ColumnTypes.DimensionAsMeasurePCPA]: true,
};
